/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M23.7915 4.2178c.2766.292.2782.7668.0035 1.0607L9.2738 20.8143.205 11.1118c-.2747-.2939-.2731-.7688.0035-1.0606.2766-.292.7235-.2903.9982.0036l8.0671 8.6308 13.5195-14.464c.2747-.294.7216-.2956.9982-.0038Z"
    clipRule="evenodd"
  />,
  'Tick'
);
